'use client';

import { SerializedEditorState } from '@payloadcms/richtext-lexical/lexical';
import { ReactNode } from 'react';
import BlockHeader from '../UIkit/BlockHeader';
import Image from 'next/image';

export interface ZMIBlockProps {
  title?: ReactNode | SerializedEditorState;
  subtitle?: ReactNode | SerializedEditorState;
  links?: Array<{
    href: string;
    image: { url: string; alt: string };
  }>;
}

export default function ZMIBlock({
  title = 'ЗМІ про нас',
  subtitle = 'AP Education — це більше, ніж освітній центр. Це місце, де народжуються й стають реальністю мрії. Наше завдання — не просто дати знання, а допомогти кожному знайти своє покликання. Ми прагнемо, щоб наші студенти виходили у світ з відчуттям впевненості у своїх силах і знаннях, які ведуть їх до успіху.',
  links = [
    {
      href: 'https://www.youtube.com/live/CGA_zOqeUck?si=cvpYAQPQn3w5Ya0-&t=7636',
      image: { url: '/assets/icon/zmi/1+1.svg', alt: '1+1' },
    },
    {
      href: 'https://promin.cv.ua/2024/08/28/chernivchan-zaproshuiut-doluchytys-do-vstanovlennia-rekordu.html',
      image: { url: '/assets/icon/zmi/chernivecka.svg', alt: 'Чернівецька' },
    },
    {
      href: 'https://kp.ua/ua/life/a696379-96-hodin-u-lvovi-proveli-rekordno-dovhij-urok-z-anhlijskoji-movi',
      image: { url: '/assets/icon/zmi/KP_new.svg', alt: 'КП' },
    },
    {
      href: 'https://ukrayina.novyny.live/vivchiti-angliisku-za-96-godin-v-ukrayini-vstanovliuiut-rekord-z-naidovshogo-uroku-195887.html',
      image: { url: '/assets/icon/zmi/Live.svg', alt: 'Live' },
    },
    {
      href: 'https://tenews.org.ua/post/show/v-ukrayini-predstavnyky-knyhy-rekordiv-fiksuyut-perebih-naytryvalishoho-uroku-anhliyskoyi-movy/',
      image: { url: '/assets/icon/zmi/TeNews.svg', alt: 'TeNews' },
    },
  ],
}: ZMIBlockProps) {
  return (
    <div
      data-meta="ZMIBlock"
      className="container max-w-7xl mx-auto px-4 py-6 sm:py-4 sm:px-6 lg:px-8"
    >
      <BlockHeader title={title} subtitle={subtitle} />
      <div className="mx-auto mt-10 grid max-w-lg grid-cols-1 items-center gap-x-8 gap-y-10 sm:max-w-xl sm:grid-cols-5 sm:gap-x-10 lg:mx-0 lg:max-w-none lg:grid-cols-5">
        {links.map((link, index) => (
          <a key={index} href={link.href} target="_blank" rel="noopener noreferrer">
            <Image
              alt={link.image.alt || ''}
              src={link.image.url || ''}
              width={158}
              height={48}
              className="col-span-2 max-h-12 w-full object-contain lg:col-span-1"
            />
          </a>
        ))}
      </div>
    </div>
  );
}
